export const throwAllErrors = (response: Response) => {
  if (!response.ok) throw new Error();

  return response;
};

export default throwAllErrors;
